export default function Cards({ children }) {
    return (
        <div className="page-cards row col-md-12">
            {children}
        </div>
    );
}